(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gatz-announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (() => {
    class GatzAnnouncementBar {
      constructor(root) {
        this.root = root;
        this.slides = [...root.querySelectorAll('[data-gza-slide]')];
        this.index = 0;
        this.paused = false;
        this.interval = (parseFloat(root.dataset.gzaSpeed) || 5) * 1000;

        for (const button of root.querySelectorAll('[data-gza-step]')) {
          button.addEventListener('click', () => {
            this.go(this.index + Number(button.dataset.gzaStep));
            this.restart();
          });
        }

        // Don't yank the message away while someone is reading or tabbing through it.
        root.addEventListener('pointerenter', () => (this.paused = true));
        root.addEventListener('pointerleave', () => (this.paused = false));
        root.addEventListener('focusin', () => (this.paused = true));
        root.addEventListener('focusout', () => (this.paused = false));

        this.go(0);

        if (this.slides.length > 1 && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.restart();
        }
      }

      go(next) {
        const total = this.slides.length;
        if (!total) return;
        this.index = ((next % total) + total) % total;
        this.slides.forEach((slide, i) => {
          // setAttribute, not toggleAttribute: toggleAttribute writes an empty
          // value rather than "true", which is what left every message stacked
          // on top of the others.
          if (i === this.index) slide.removeAttribute('aria-hidden');
          else slide.setAttribute('aria-hidden', 'true');
        });
      }

      restart() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (!this.paused && !document.hidden) this.go(this.index + 1);
        }, this.interval);
      }

      destroy() {
        clearInterval(this.timer);
      }
    }

    let instance = null;
    let pending = false;

    function init() {
      const root = document.querySelector('[data-gza-root]');
      if (instance) instance.destroy();
      instance = root ? new GatzAnnouncementBar(root) : null;
    }

    // The free shipping and Mix & Match lines are worked out in Liquid, so cart
    // totals, the money format and collection membership all stay server-side.
    // When the cart changes we ask Shopify to re-render just this section.
    async function refresh() {
      const root = document.querySelector('[data-gza-root]');
      if (!root || !root.hasAttribute('data-gza-live') || pending) return;

      const id = root.dataset.gzaSection;
      if (!id) return;

      pending = true;
      try {
        const url = new URL(window.location.href);
        url.searchParams.set('sections', id);
        const response = await fetch(url.toString());
        if (!response.ok) return;

        const data = await response.json();
        const html = data[id];
        if (typeof html !== 'string') return;

        const next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-gza-root]');
        const current = document.querySelector('[data-gza-root]');
        if (!current) return;

        if (!next) {
          current.remove();
          if (instance) instance.destroy();
          instance = null;
          return;
        }

        current.replaceWith(next);
        init();
      } catch (_) {
        // Leave the bar showing whatever it last rendered.
      } finally {
        pending = false;
      }
    }

    document.addEventListener('cart:update', refresh);
    document.addEventListener('discount:update', refresh);
    document.addEventListener('shopify:section:load', init);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gatz-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  var KEY = 'gatz:plp-density';
  function init(root) {
    if (!root || root.dataset.gcReady === '1') return;
    root.dataset.gcReady = '1';
    var buttons = root.querySelectorAll('[data-gc-density]');
    function paint(value) {
      root.setAttribute('data-density', value);
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].setAttribute('aria-pressed', buttons[i].getAttribute('data-gc-density') === value ? 'true' : 'false');
      }
    }
    var saved = null;
    try { saved = localStorage.getItem(KEY); } catch (e) {}
    paint(saved === '1' || saved === '2' ? saved : (root.getAttribute('data-density') || '2'));
    for (var j = 0; j < buttons.length; j++) {
      buttons[j].addEventListener('click', function () {
        var v = this.getAttribute('data-gc-density');
        paint(v);
        try { localStorage.setItem(KEY, v); } catch (e) {}
      });
    }
    var sort = root.querySelector('[data-gc-sort]');
    if (sort) sort.addEventListener('change', function () { if (this.form) this.form.submit(); });
    var fbtn = root.querySelector('[data-gc-filter]');
    var panel = root.querySelector('#gc-filterpanel');
    if (fbtn && panel) {
      if (panel.querySelector('.gc-chip.is-on')) { panel.hidden = false; fbtn.setAttribute('aria-expanded', 'true'); }
      fbtn.addEventListener('click', function () {
        var open = panel.hidden;
        panel.hidden = !open;
        fbtn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
    // Only nudge the category bar when the current item is actually out of view.
    // The previous version ran whenever the row overflowed at all, so the bar
    // visibly lurched sideways on every load — that was the wobble.
    var strip = root.querySelector('[data-gc-catbar] .gc-catbar__list');
    var here = strip && strip.querySelector('.is-current');
    if (strip && here && strip.scrollWidth > strip.clientWidth + 2) {
      var s = strip.getBoundingClientRect();
      var h = here.getBoundingClientRect();
      if (h.left < s.left + 2 || h.right > s.right - 2) {
        strip.scrollLeft += (h.left - s.left) - 20;
      }
    }
  }
  function boot() {
    var roots = document.querySelectorAll('[data-gc-root]');
    for (var i = 0; i < roots.length; i++) init(roots[i]);
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gatz-editorial-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) card.scrollIntoView({ behavior: 'instant' });
      },
      { once: true }
    );
  }

  // Bring the current category into view, but only when it is actually
  // off-screen — otherwise the bar visibly lurches sideways on every load.
  document.addEventListener(
    'DOMContentLoaded',
    () => {
      for (const bar of document.querySelectorAll('[data-gzc-cats]')) {
        const current = bar.querySelector('[data-gzc-current]');
        if (!current) continue;
        const barBox = bar.getBoundingClientRect();
        const itemBox = current.getBoundingClientRect();
        if (itemBox.left < barBox.left || itemBox.right > barBox.right) {
          bar.scrollLeft += itemBox.left - barBox.left - 16;
        }
      }
    },
    { once: true }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-boheme"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
